"use client"
import type React from "react"
import { useState } from "react"
import { type CryptoData } from "@/lib/api"
import { chainImgs } from "@/lib/imgs"

export default function CryptoIcon({ coin, size = 8, className }: { coin: CryptoData, size?: number, className?: string }) {
    const [showFallback, setShowFallback] = useState(false)
    
    if (!coin || (!coin?.coinSymbol && !coin?.tokenSymbol)) return null;
    // 根据coin.symbol找到对应的chainImgs存在key
    // 优先获取coinIcon
    const coinIcon = coin?.coinIcon || coin?.icon || ''
    // 获取coinSymbol
    const coinSymbol = coin?.coinSymbol || coin?.tokenSymbol
    // 获取chainImgs
    const values = Object.values(chainImgs)
    // 获取chainIcon
    let chainIcon = values.find(value => value.toLocaleLowerCase().includes(coinSymbol?.toLocaleLowerCase() || '')) || ''
    // 如果图标不存在，则获取对象的数据
    if (!chainIcon) {
        chainIcon = chainImgs[coinSymbol?.toLocaleLowerCase() || ''] || chainImgs[coinSymbol || '']
    }
    
    // 如果coinIcon或chainIcon不存在，则显示fallback
    if (showFallback || (!coinIcon && !chainIcon)) {
        return (
            <div
                className={`w-${size} h-${size} flex-none rounded-full flex items-center justify-center font-bold text-sm text-font-primary bg-primary/40 ${className}`}
            >
                {coinSymbol?.[0]?.toUpperCase()}
            </div>
        )
    }
    
    return (
        <img 
            src={chainIcon || coinIcon} 
            alt={coinSymbol} 
            className={`w-${size} h-${size} rounded-full ${className}`} 
            onError={(e) => {
                if (chainIcon && e.currentTarget.src !== chainIcon) {
                    e.currentTarget.src = chainIcon
                } else {
                    // 当 chainIcon 不存在或也加载失败时，显示首字母
                    setShowFallback(true)
                }
            }}
        />
    )
}
